import { SvgIcon, SvgIconProps } from '@mui/material'
import { FC } from 'react'

export const BrokenLinkIcon: FC<SvgIconProps> = (props) => {
  return (
    <SvgIcon
      width="85"
      height="84"
      viewBox="0 0 85 84"
      fill="none"
      stroke="#00598E"
      xmlns="http://www.w3.org/2000/svg"
      {...props}
    >
      <path
        d="M62.5 82V72M72.5 62H82.5M17.75 38.465L10.68 45.535C6.92918 49.2858 4.82198 54.373 4.82198 59.6775C4.82198 64.982 6.92918 70.0692 10.68 73.82C14.4308 77.5708 19.518 79.678 24.8225 79.678C30.127 79.678 35.2142 77.5708 38.965 73.82L46.04 66.75M12.5 22H2.5M22.5 2V12M38.965 17.25L46.035 10.18C47.8846 8.28886 50.091 6.78342 52.5264 5.75086C54.9618 4.7183 57.5779 4.17912 60.2231 4.16455C62.8684 4.14999 65.4902 4.66032 67.9368 5.66599C70.3835 6.67167 72.6063 8.15271 74.4767 10.0234C76.347 11.894 77.8276 14.1171 78.8329 16.5639C79.8381 19.0108 80.348 21.6327 80.333 24.2779C80.3179 26.9232 79.7783 29.5391 78.7453 31.9744C77.7123 34.4096 76.2065 36.6157 74.315 38.465L67.245 45.535"
        stroke="inherit"
        fill="none"
        strokeWidth="4"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
    </SvgIcon>
  )
}
